var version;
var hasRequiredVersion;

function requireVersion () {
	if (hasRequiredVersion) return version;
	hasRequiredVersion = 1;
	version = "0.8.5";
	return version;
}

export { requireVersion as __require };
//# sourceMappingURL=version.js.map
